import { Share } from '@ts/components/Share';

export const init = () => {
    setPrintReceipt();
    setShareSite();
}

const setPrintReceipt = () => {
    const printBtn = document.querySelector('.print-receipt');
    if (!printBtn) return;

    const cleanup = () => {
        document.body.classList.remove('print-receipt-mode');
        window.removeEventListener('afterprint', cleanup);
    };

    printBtn.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('print-receipt-mode');
        window.addEventListener('afterprint', cleanup, { once: true });
        window.print();

        // fallback in case afterprint does not fire in some browsers
        setTimeout(cleanup, 1000);
    });
};

const setShareSite = () => {
    // share-btn
    const shareBtns = document.querySelectorAll('.keep-going .share-btn');
    shareBtns.forEach((btn) => {
        const webshare = Share.create(btn, {
            url: btn.dataset.shareUrl,
            text: btn.dataset.shareText
        });
    });
}
